import { InventoryStockLocationFilterParams } from '@/renderer/types/inventory';
import { Button, DropdownSelect, Input } from '@components/common';
import { INVENTORY_STOCK_LOCATION_TYPE_OPTIONS } from './stockLocationForm';

interface StockLocationsToolbarProps {
  outletName: string;
  searchQuery: string;
  typeFilter: InventoryStockLocationFilterParams['type'];
  statusFilter: InventoryStockLocationFilterParams['status'];
  onSearchChange: (value: string) => void;
  onTypeChange: (value: InventoryStockLocationFilterParams['type']) => void;
  onStatusChange: (value: InventoryStockLocationFilterParams['status']) => void;
  onCreate: () => void;
}

export function StockLocationsToolbar({
  outletName,
  searchQuery,
  typeFilter,
  statusFilter,
  onSearchChange,
  onTypeChange,
  onStatusChange,
  onCreate,
}: StockLocationsToolbarProps) {
  return (
    <div className="rounded-2xl border border-gray-200 bg-white p-4 shadow-sm">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <h3 className="text-lg font-semibold text-gray-900">
            Stock allocation
          </h3>
          <p className="mt-1 text-sm text-gray-500 max-w-[80%]">
            Define the physical and logical storage points for {outletName} so
            future balances, movements, recipes, and deductions know where stock
            lives.
          </p>
        </div>
        <div className="flex items-center w-fit h-fit">
          <Button className="w-[120px]" onClick={onCreate}>
            Add location
          </Button>
        </div>
      </div>

      <div className="mt-4 grid gap-4 md:grid-cols-3">
        <Input
          label="Search"
          value={searchQuery}
          onChange={onSearchChange}
          placeholder="Search by name, type, or description"
        />
        <DropdownSelect
          label="Type"
          value={typeFilter ?? 'all'}
          options={[
            { value: 'all', label: 'All types' },
            ...INVENTORY_STOCK_LOCATION_TYPE_OPTIONS,
          ]}
          onChange={(value) =>
            onTypeChange(value as InventoryStockLocationFilterParams['type'])
          }
        />
        <DropdownSelect
          label="Status"
          value={statusFilter ?? 'all'}
          options={[
            { value: 'all', label: 'All statuses' },
            { value: 'active', label: 'Active' },
            { value: 'inactive', label: 'Inactive' },
          ]}
          onChange={(value) =>
            onStatusChange(
              value as InventoryStockLocationFilterParams['status'],
            )
          }
        />
      </div>
    </div>
  );
}
